<div class="catalogue-product-card"  (click)="onCardClick()">
  <img 
      [src]="product?.imageUrl" 
      alt="catalogue"
      loading="lazy"
      (error)="onImageError($event)"/>
  <section class="product-info">
    <span class="heading-xs">{{ product?.name }}</span>
    <span class="body-m">
        {{ getNoteNames(product?.noteFamilies) }}
    </span>
    <span class="body-l-bold">{{ product?.transactionalPrice?.value | defaultCurrency:product?.transactionalPrice?.currencyCode }}</span>
    <span class="body-s text-dark-alt">{{ 'fragrance-catalogue.vat' | translate }}</span>
  </section>
</div>